import { render, staticRenderFns } from "./PropostaLista.vue?vue&type=template&id=766c2f71&"
import script from "./PropostaLista.vue?vue&type=script&lang=js&"
export * from "./PropostaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports